import React from "react";
import { LegalPage } from "../../components/marketing/LegalPage";
import { termsSections } from "../../data/legal";
export function Terms() {
  return <LegalPage title="Terms of Service" updated="September 1, 2026" sections={termsSections} data-id="element-1919" data-mp="1tpbb66x8lvn1" />;
}